<template>
  <div class="position-relative overflow-hidden h-100">
    <div class="zoom-area-container" :style="{ '--zoom-value': zoomValue }">
      <div ref="zoomArea" class="zoom-area" :style="{ width }">
        <slot></slot>
      </div>
    </div>

    <div v-if="!hideControls" class="zoom-controls">
      <b-button-group>
        <b-button
          squared
          @click="lessZoom"
          variant="primary"
          class="p-2 border-med-light-gray"
          ><img :src="require('../../assets/icons/less.png')"
        /></b-button>
        <b-button
          squared
          @click="addZoom"
          variant="outline-primary"
          class="p-2 border-med-light-gray"
          ><img :src="require('../../assets/icons/plus.png')"
        /></b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZoomArea",
  props: ["width", "hideControls"],
  data() {
    return {
      zoomValue: 1,
      zoomStep: 0.1
    };
  },
  mounted() {
    if (this.width) {
      requestAnimationFrame(() => {
        const zoomArea = this.$refs["zoomArea"];
        const container = zoomArea.parentNode;
        const zoomAreaWidth = zoomArea.getBoundingClientRect().width;
        const containerWidth = container.getBoundingClientRect().width;

        const relation = (containerWidth - 5) / zoomAreaWidth;
        this.zoomValue = relation;
      });
    }
  },
  methods: {
    addZoom() {
      if (this.zoomValue < 3) this.zoomValue = this.zoomValue + this.zoomStep;
    },
    lessZoom() {
      if (this.zoomValue > 0.2) this.zoomValue = this.zoomValue - this.zoomStep;
    }
  }
};
</script>

<style scoped>
.zoom-controls {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.zoom-area-container {
  position: relative;
  height: 100%;
  overflow: auto;
}
.zoom-area {
  position: absolute;
  transform: scale(var(--zoom-value));
  transform-origin: 0% 0% 0px;
}
</style>
